import './style.css';
import { useEffect, useState } from 'react';
import { Outlet, useLoaderData } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';
import { LoadingIndicator } from '@thermon-platforms/thermon-ui-core';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';


const ProtectedRoute = () => {
  const [usersStore, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();
  const [waiting, setWaiting] = useState(true);
  const {access} = useLoaderData();

  useEffect(() => {
    if (usersStore.currentUser && rolesStore.roles.length) {
      setWaiting(false);
    }
  }, [usersStore, rolesStore]);

  // Wait for necessary resources to load
  if (waiting) return (
    <div className="view waiting">
      <LoadingIndicator show={true} />
    </div>
  );

  // Check if any of the current user's roles can access this view
  const canAccess = access.some(permission =>
    usersStoreActions.checkAccess(permission, rolesStore.roles)
  );

  if (!canAccess) {
    return(
      <div className="view unauthorized">
        <h2><Trans>Unauthorized</Trans></h2>
        <p>
          <Trans>This account is not authorized to view this component.</Trans>
        </p>
      </div>
    );
  }

  // Render route if authorized
  return <Outlet />;
}

export default ProtectedRoute;
